import { render } from "./StatisticsTable.vue?vue&type=template&id=322548d5&scoped=true&ts=true"
import script from "./StatisticsTable.vue?vue&type=script&lang=ts"
export * from "./StatisticsTable.vue?vue&type=script&lang=ts"

import "./StatisticsTable.vue?vue&type=style&index=0&id=322548d5&scoped=true&lang=scss"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322548d5"]])

export default __exports__